import Vue from 'vue';
import App from './App.vue';
import vuetify from '@/plugins/vuetify';
import router from '@/routes/index';
import store from '@/store/index';
//import { i18n } from './plugins/locales'; //--다국어 ejkim
// import { errorLogout } from '@/utils/errorUtil';

Vue.config.productionTip = false;

Vue.config.errorHandler = () => {
  // alert(`오류가 발생했습니다 (${e.message})`);

  // 스피너 OFF
  store.commit('SPINNER/OFF_COMMON_SPINNER');
  store.commit('SPINNER/OFF_APP_SPINNER');

  // errorLogout();
};

Vue.config.warnHandler = e => {
  console.log(e);
};

Vue.prototype.$domain =
  process.env.NODE_ENV === 'production'
    ? `${window.location.protocol}//${window.location.host}`
    : 'https://dev1.workup.plus';

// Vue.loadScript(
//   'https://dev1.workup.plus/ReportingServer/html5/js/jquery-1.11.0.min.js',
// );
// Vue.loadScript(
//   'https://dev1.workup.plus/ReportingServer/html5/js/crownix-viewer.min.js',
// );
// Vue.loadScript(
//   'https://dev1.workup.plus/ReportingServer/html5/css/crownix-viewer.min.css',
// );

//Vue.use({ install: i18nComponentInstall });

const vm = new Vue({
  render: h => h(App),
  vuetify,
  router,
  //i18n, // --다국어 ejkim
  store,
  // loadScript,
}).$mount('#app');

window.app = vm;
